<!-- @format -->

@if (products?.length > 0) {
  <sis-carousel
    [control]="selectedProductIndexControl"
    [selectedSlideId]="initialSelection"
    [mobileView]="mobileView"
    [carouselHeaderId]="carouselHeaderId"
    mobileViewDescription="OPEN_UNIVERSITY.STUDY_OFFERING.BROWSE_COMPLETION_METHODS"
    prevAriaLabel="OPEN_UNIVERSITY.STUDY_OFFERING.BROWSE_COMPLETION_METHODS_BACKWARD"
    nextAriaLabel="OPEN_UNIVERSITY.STUDY_OFFERING.BROWSE_COMPLETION_METHODS_FORWARD"
    contentRole="radiogroup">
    @for (product of products; track entityId(index, product); let index = $index) {
      <sis-carousel-selection-box-slide
        [control]="selectedProductIndexControl"
        [translatedTitle]="product.name | localizedString"
        [titleBadgeText]="product.isPurchased ? 'OPEN_UNIVERSITY.STUDY_OFFERING.PURCHASED' : undefined"
        [titleBadgeVariant]="product.isPurchased ? 'success' : undefined"
        [id]="product.id"
        [value]="index"
        [name]="name"
        [banners]="product | productSlideBanner | async"
        (selectedIdEvent)="onProductSelect($event)">
        <app-carousel-product-info [product]="product" [id]="product?.id + '-info'" sisDescribedByContent></app-carousel-product-info>
        @if (mobileView) {
          <app-product-details [courseUnit]="courseUnit" [product]="product" [mobileView]="true" class="mt-5"> </app-product-details>
        }
      </sis-carousel-selection-box-slide>
    }
  </sis-carousel>
}
